import { capitalize } from '../../utils/string.helpers';
export const buildAddress = ({ line_1, line_2, line_3 }) => `${line_1} ${line_2} ${line_3}`.trim();
export const getOrderDetailsList = ({ merchantNumber }, translate) => [
    {
        id: 'merchant-id',
        text: String(merchantNumber),
        label: translate('CONFIRM.MERCHANT_ID'),
        isBold: true,
    },
    {
        id: 'product-description',
        text: translate('CONFIRM.INSIGHTS_SUBSCRIPTION'),
        label: translate('CONFIRM.PRODUCT_DESCRIPTION'),
        isBold: true,
    },
];
export const getMerchantDetailsList = ({ addressComponent, businessSubtype, businessType, businessName, businessLegalName }, translate) => {
    const { city, province_code, postal_code } = addressComponent;
    const formattedAddressArr = [
        capitalize(buildAddress(addressComponent), true),
        `${capitalize(city)}, ${province_code}, ${postal_code}`,
    ];
    return [
        {
            id: 'merchant-legal-name',
            text: businessLegalName,
            label: translate('CONFIRM.MERCHANT_LEGAL_NAME'),
            isBold: true,
        },
        {
            id: 'merchant-name',
            text: businessName,
            label: translate('CONFIRM.MERCHANT_NAME'),
            isBold: true,
        },
        {
            id: 'merchant-address',
            text: formattedAddressArr,
            label: translate('CONFIRM.BUSINESS_ADDRESS'),
            isSemiBold: true,
        },
        {
            id: 'mcc-group',
            text: capitalize(businessType),
            label: translate('CONFIRM.BUSINESS_TYPE'),
            isSemiBold: true,
        },
        {
            id: 'mcc-def',
            text: capitalize(businessSubtype),
            label: translate('CONFIRM.BUSINESS_SUBTYPE'),
            isSemiBold: true,
        },
    ];
};
export const getPricingDetailsList = (translate) => [
    {
        id: 'monthly-price',
        text: '$14.99',
        label: translate('CONFIRM.MONTHLY_PRICE'),
        isBold: true,
    },
    {
        id: 'regional-tax',
        text: '$1.95',
        label: [translate('CONFIRM.REGIONAL_TAX'), '(10% GST + 3% HST)'], // TODO - add tax details and translate them
        isBold: true,
    },
    {
        id: 'total-price',
        text: '$16.95',
        label: translate('CONFIRM.TOTAL_AMOUNT'),
        isBold: true,
        labelClass: 'totalPrice',
    },
];
export const getMerchantPersonalDetailsList = ({ ssoUsername, firstName, lastName, mobileNumber }, translate) => {
    return [
        {
            id: 'merchant-first-name',
            text: firstName,
            label: translate('REVIEW.MERCHANT_FIRST_NAME'),
            isBold: true,
        },
        {
            id: 'merchant-last-name',
            text: lastName,
            label: translate('REVIEW.MERCHANT_LAST_NAME'),
            isSemiBold: true,
        },
        {
            id: 'merchant-business-address',
            text: '',
            // TODO: POPULATE WITH MERCHANT ADDRESS
            label: translate('CONFIRM.MERCHANT_ADDRESS'),
            isSemiBold: true,
        },
        {
            id: 'merchant-email',
            text: ssoUsername,
            label: translate('REVIEW.MERCHANT_EMAIL'),
            isSemiBold: true,
        },
        {
            id: 'merchant-phone-number',
            text: mobileNumber,
            label: translate('REVIEW.MERCHANT_PHONE_NUMBER'),
            isSemiBold: true,
        },
    ];
};
